export default __webpack_public_path__ + "static/media/owner-account-green-icons.cdd311af.svg";